import { clear, del, query } from '@wdg/history';
import { Slider } from '../card-slider/view-script.js';

class MyAspenHistory {
	constructor( node ) {
		this.node = node;
		this.empty = this.node.querySelector( '.my-aspen-history__empty' );
		this.filter = null;
		this.items = this.node.querySelector( '.my-aspen-history__items' );
		this.filters = this.node.querySelector( '.my-aspen-history__filters' );
		this.facet = this.node.dataset.facet ?? 'type';
		this.activeFilter = 'my-aspen-history__filter--active';

		this.node.addEventListener( 'click', ( e ) => {
			let target = e.target;

			while ( target && target !== this.node ) {
				if ( target.matches( '.my-aspen-history__clear' ) ) {
					e.preventDefault();
					return this.clear( target );
				}

				if ( target.matches( '.my-aspen-history__remove' ) ) {
					e.preventDefault();
					return this.remove( target.value );
				}

				if ( target.matches( '.my-aspen-history__filter button' ) ) {
					e.preventDefault();

					for ( const filter of this.node.querySelectorAll( '.my-aspen-history__filter--active' ) ) {
						filter.classList.remove( 'my-aspen-history__filter--active' );
					}

					target.closest( '.my-aspen-history__filter' ).classList.add( 'my-aspen-history__filter--active' );

					return this.setFilter( target?.value ?? '' );
				}

				target = target.parentNode;
			}
		} );

		this.slider = new Slider( this.node, {
			back: '.my-aspen-history__go--back',
			forward: '.my-aspen-history__go--forward',
			content: '.my-aspen-history__content',
			items: '.my-aspen-history__items > *',
			sticky: false,
		} );
	}

	async fetch() {
		try {
			this.node.classList.add( 'is-loading' );
			this.data = await query( {
				facet: this.facet,
				filter: this.filter ?? null,
			} );

			while ( this.items.firstChild ) {
				this.items.removeChild( this.items.firstChild );
			}

			for ( const item of this.data.items ) {
				if ( item.view ) {
					this.items.insertAdjacentHTML( 'beforeend', item.view );
					this.items.children[ this.items.children.length - 1 ].classList.add( 'my-aspen-history__item' );
				}
			}

			if ( this.slider ) {
				this.slider.querySelectors();
				this.slider.setIndex( 0 );
			}
		} catch ( fault ) {
			console.error( fault );
		} finally {
			this.node.classList.remove( 'is-loading' );
		}
	}

	async clear() {
		this.node.classList.add( 'is-loading' );

		try {
			const result = await clear();

			if ( ! result ) {
				throw new Error( 'unable to clear' );
			}

			for ( const node of this.node.querySelectorAll( '.my-aspen-history__items' ) ) {
				node.parentNode.removeChild( node );
			}

			for ( const node of this.node.querySelectorAll( '.my-aspen-history__term' ) ) {
				node.parentNode.removeChild( node );
			}

			this.empty.removeAttribute( 'hidden' );
		} catch ( fault ) {
			console.error( fault );
		} finally {
			this.node.classList.remove( 'is-loading' );
		}
	}

	async remove( id ) {
		const item = this.node.querySelector( `.my-aspen-history__item[data-id="${ id }"]` );

		if ( ! item ) {
			return;
		}

		item.classList.add( 'is-loading' );

		try {
			const result = await del( id );

			if ( ! result ) {
				console.error( result );
				throw new Error( 'unable to remove item from history' );
			}

			item.parentNode.removeChild( item );

			if ( this.node.querySelectorAll( '.my-aspen-history__items' ).length === 0 ) {
				this.empty.removeAttribute( 'hidden' );
			}
		} catch ( fault ) {
			console.error( fault );
		} finally {
			if ( item.parentNode ) {
				item.classList.remove( 'is-loading' );
			}
		}
	}

	setFilter( value ) {
		this.filter = value;
		this.fetch();
	}
}

for ( const node of document.querySelectorAll( '.my-aspen-history' ) ) {
	new MyAspenHistory( node );
}
